module.exports = __webpack_public_path__ + "static/media/Moldflow.320cd141.png";